/**
 * 全局过滤器
 */
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

/**
 * 功能：将时间戳按照给定的 时间/日期 格式进行处理
 * @param {Number} date 时间戳
 * @returns {String} 规范后的 时间/日期 字符串
 */
let formatDate = function (date) {
    if (!date) {
        return date;
    }
    return dayjs(date).format('YYYY-MM-DD dddd'); // 使用 dayjs 格式化时间
};

let formatTime = (date) => {
    if (!date) {
        return date;
    }
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss') // 使用 dayjs 格式化时间
}
let tool_unix = (data) => {
    if ((isNaN(data) == 0) && (data.length == 13)) {
        return data / 1000
    } else {
        return data
    }
}
let formatDuring = (date) => {
    if (!date) return date;
    let days    = date / 1000 / 60 / 60 / 24;
    let daysRound = Math.floor(days);
    let hours = date / 1000 / 60 / 60 - (24 * daysRound);
    let hoursRound = Math.floor(hours);
    let minutes = date / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
    let minutesRound = Math.floor(minutes);
    let seconds = date / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
    seconds = seconds + '';
    seconds = seconds.split(".")[0];
    hoursRound = hoursRound < 10 ? '0' + hoursRound : hoursRound;
    minutesRound = minutesRound < 10 ? '0' + minutesRound : minutesRound;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    if(daysRound > 0){
        return `${daysRound}:${hoursRound}:${minutesRound}:${seconds}`
    }else{
        return `${hoursRound}:${minutesRound}:${seconds}`
    }
}
/**
 * 功能：将给定的时间/日期转换成时间戳进行处理
 * @param {Number} date 给定的时间/日期
 * @returns {String} 规范后的 时间戳
 */
let timestamp = (date) => {
    if (!date) {
        return date;
    }
    return dayjs(date).valueOf() // 使用 dayjs 格式化时间
}
export { formatDate, formatTime, tool_unix, formatDuring, timestamp }